import { Location } from "react-router-dom";

import { ERoutes } from "@utils/constants";

export const isActiveNavItem = (location: Location, routes: ERoutes[]) =>
  routes.some((route) => location.pathname === route);
